import MostPopularProducts from './components/MostPopularProducts'
import ProductList from './components/products/ProductList';
import ProductItem from './components/products/partials/ProductItem';
import Carousel from './components/components/CarouselComponent'
import AddToCart from './components/shop/cart/AddToCart';

import Vue from 'vue'
import Vuex from 'vuex'
import PortalVue from 'portal-vue'
import VueCurrencyFilter from 'vue-currency-filter'
import {cart, Shop} from '@webapix/shop-js'

import CartWidgetToggle from './components/shop/cart/CartWidgetToggle';
import Product from './components/products/Product';
import AddToWishlistCollection from './components/listCollections/AddToWishlistCollection';
import ResponsiveImage from './components/mediaLibrary/ResponsiveImage';
import CartWidget from './components/shop/cart/CartWidget';
import CheckoutBase from './components/shop/checkout/CheckoutBase';
import Addresses from './components/addresses/Addresses';
import NewAddressForm from './components/addresses/NewAddressForm';
import AddressItem from './components/addresses/AddressItem';
import NewShippingAddressForm from './components/addresses/NewShippingAddressForm';
import NewBillingAddressForm from './components/addresses/NewBillingAddressForm';
import CreateShippingAddressModal from './components/shop/checkout/steps/customerData/CreateShippingAddressModal';
import GuestCustomerDataForm from './components/addresses/GuestCustomerDataForm';
import BillingAddressSelector from './components/shop/checkout/steps/customerData/BillingAddressSelector';
import ShippingAddressSelector from './components/shop/checkout/steps/customerData/ShippingAddressSelector';
import VueMultiselect from 'vue-multiselect';
import HeaderMenu from './components/HeaderMenu';
import CartWidgetItem from './components/shop/cart/CartWidgetItem';
import ProductFilters from './components/productCategory/ProductFilters';
import Checkout from './components/shop/checkout/Checkout';
import CheckoutSteps from './components/shop/checkout/steps/CheckoutSteps';
import Cart from './components/shop/cart/Cart';
import CartItem from './components/shop/cart/CartItem';
import Authentication from './components/shop/checkout/steps/Authentication';
import ShippingMode from './components/shop/checkout/steps/ShippingMode';
import PaymentMode from './components/shop/checkout/steps/PaymentMode';
import MobileCartWidgetToggle from './components/shop/cart/MobileCartWidgetToggle';
import PhoneNumberField from './components/shop/cart/PhoneNumberField';
import EmbedContentsToPortals from './components/embed-content/EmbedContentsToPortals';
import CheckoutStep from './components/shop/checkout/steps/CheckoutStep';
import AddedToCartModal from './components/shop/cart/AddedToCartModal';
import SummaryStep from './components/shop/checkout/steps/SummaryStep';
import CreateBillingAddressModal from './components/shop/checkout/steps/customerData/CreateBillingAddressModal';
import RedirectToPayment from './components/shop/RedirectToPayment';
import Collapsible from './components/Collapsible';
import PickupPointStores from './components/shop/pickupPoints/PickupPointStores';
import GlsPickupPoints from './components/shop/pickupPoints/GlsPickupPoints';
import AuthenticatedCustomerDataForm from './components/shop/checkout/steps/customerData/AuthenticatedCustomerDataForm';
import ProductItemList from './components/products/ProductItemList';
import * as GmapVue from 'gmap-vue';
import Maps from './components/storeFinder/Maps';
import StoreFindex from './components/storeFinder/StoreFindex';
import RequiredSizeModal from './components/shop/cart/RequiredSizeModal';
import PercentCoupon from './components/shop/discounts/PercentCoupon';
import GiftCardCoupon from './components/shop/discounts/GiftCardCoupon';
import BudmilSimpleCoupon from './components/shop/discounts/BudmilSimpleCoupon';

import ProductReturn from './components/productReturn/ProductReturn';
import ProductReturnOrdersList from './components/productReturn/ProductReturnOrdersList';
import ProductReturnProductList from './components/productReturn/ProductReturnProductList';
import ProductReturnProducts from './components/productReturn/ProductReturnProducts';
import ProductReturnSummary from './components/productReturn/ProductReturnSummary';

import VueTailwind from 'vue-tailwind'
import 'tailwindcss/tailwind.css'
import {
    TAlert,
    TButton,
    TCard,
    TCheckbox,
    TCheckboxGroup,
    TDatepicker,
    TDialog,
    TDropdown,
    TInput,
    TInputGroup,
    TModal,
    TPagination,
    TRadio,
    TRadioGroup,
    TRichSelect,
    TSelect,
    TTable,
    TTag,
    TTextarea,
    TToggle,
} from 'vue-tailwind/dist/components';
import CouponRedeemForm from './components/shop/cart/CouponRedeemForm';
import CustomerData from './components/shop/checkout/steps/CustomerData';
import RelatedProducts from './components/products/RelatedProducts';
import NewsletterPopup from './components/popups/NewsletterPopup';
import OutOfStockModal from './components/shop/cart/OutOfStockModal';
import Banner from './components/products/partials/Banner';
import vueAwesomeCountdown from 'vue-awesome-countdown'
import BudmilCountdown from './components/BudmilCountdown';
import GiftCardModal from './components/shop/cart/GiftCardModal';
import GlsParcelLocker from "./components/shop/pickupPoints/GlsParcelLocker";
import MplParcelLocker from './components/shop/pickupPoints/MplParcelLocker';
import MplPickupPoints from './components/shop/pickupPoints/MplPickupPoints';
import PostOffices from './components/shop/pickupPoints/PostOffices';
import DpdParcelLocker from './components/shop/pickupPoints/DpdParcelLocker'
import DpdParcelPoint from './components/shop/pickupPoints/DpdParcelPoint'
import Loading from './components/Loading.vue'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('vue-multiselect', VueMultiselect)

Vue.use(GmapVue, {
    load: {
        key: 'AIzaSyB6QzOe266n3P9MqZqytOlUB95XwAXeSpg',
    },
})
Vue.use(VueTailwind, {
    TInput,
    TTextarea,
    TSelect,
    TRadio,
    TCheckbox,
    TButton,
    TInputGroup,
    TCard,
    TAlert,
    TModal,
    TDropdown,
    TRichSelect,
    TPagination,
    TTag,
    TRadioGroup,
    TCheckboxGroup,
    TTable,
    TDatepicker,
    TToggle,
    TDialog,
})
Vue.use(Vuex)
Vue.use(PortalVue)
Vue.use(VueCurrencyFilter, [
    {
        symbol: '€',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'back',
        symbolSpacing: true,
        avoidEmptyDecimals: '',
    },
    {
        name: 'currencyEur',
        symbol: '€',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'back',
        symbolSpacing: true,
        avoidEmptyDecimals: '',
    },
    {
        name: 'Huf',
        symbol: 'Ft',
        thousandsSeparator: ' ',
        fractionCount: 0,
        fractionSeparator: '.',
        symbolPosition: 'back',
        symbolSpacing: true,
        avoidEmptyDecimals: '',
    }
])
Vue.use(Shop)
Vue.component('most-popular-products', MostPopularProducts);
Vue.component('product-list', ProductList)
Vue.component('product-item', ProductItem)
Vue.component('product-item-list', ProductItemList)
Vue.component('carousel-component', Carousel)
Vue.component('cart-widget-toggle', CartWidgetToggle)
Vue.component('mobile-cart-widget-toggle', MobileCartWidgetToggle)
Vue.component('checkout', Checkout)
Vue.component('product', Product)
Vue.component('add-to-cart', AddToCart)
Vue.component('cart-widget', CartWidget)
Vue.component('add-to-wishlist-collection', AddToWishlistCollection)
Vue.component('responsive-image', ResponsiveImage)
Vue.component('checkout-base', CheckoutBase)
Vue.component('header-menu', HeaderMenu)
Vue.component('cart-widget-item', CartWidgetItem)
Vue.component('product-filters', ProductFilters)
Vue.component('checkout-steps', CheckoutSteps)
Vue.component('cart', Cart)
Vue.component('cart-item', CartItem)
Vue.component('authentication', Authentication)
Vue.component('customer-data', CustomerData)
Vue.component('authenticated-customer-data-form', AuthenticatedCustomerDataForm)
Vue.component('shipping-mode', ShippingMode)
Vue.component('payment-mode', PaymentMode)
Vue.component('summary-step', SummaryStep)
Vue.component('phone-number-field', PhoneNumberField)
Vue.component('embed-contents-to-portals', EmbedContentsToPortals)
Vue.component('checkout-step', CheckoutStep)
Vue.component('added-to-cart-modal', AddedToCartModal)
Vue.component('required-size-modal', RequiredSizeModal)
Vue.component('create-shipping-address-modal', CreateShippingAddressModal)
Vue.component('new-shipping-address-form', NewShippingAddressForm)
Vue.component('shipping-address-selector', ShippingAddressSelector)
Vue.component('create-billing-address-modal', CreateBillingAddressModal)
Vue.component('new-billing-address-form', NewBillingAddressForm)
Vue.component('billing-address-selector', BillingAddressSelector)
Vue.component('new-address-form', NewAddressForm)
Vue.component('pickup-point-stores', PickupPointStores)
Vue.component('gls-pickup-points', GlsPickupPoints)
Vue.component('gls-parcel-locker', GlsParcelLocker)
Vue.component('percent-coupon', PercentCoupon)
Vue.component('gift-card-coupon', GiftCardCoupon)
Vue.component('budmil-simple-coupon', BudmilSimpleCoupon)
Vue.component('GiftCardCoupon', GiftCardCoupon)
Vue.component('PercentCoupon', PercentCoupon)
Vue.component('BudmilSimpleCoupon', BudmilSimpleCoupon)
Vue.component('budmil-countdown', BudmilCountdown)
Vue.use(vueAwesomeCountdown, 'countdown')
Vue.component('gift-card-modal', GiftCardModal)

Vue.component('addresses', Addresses)
Vue.component('address-item', AddressItem)
Vue.component('guest-customer-data-form', GuestCustomerDataForm)
Vue.component('shipping-address-selector', ShippingAddressSelector)
Vue.component('redirect-to-payment', RedirectToPayment)
Vue.component('collapsible', Collapsible)
Vue.component('maps', Maps)
Vue.component('store-finder', StoreFindex)
Vue.component('coupon-redeem-form', CouponRedeemForm)
Vue.component('related-products', RelatedProducts)
Vue.component('newsletter-popup', NewsletterPopup)
Vue.component('out-of-stock-modal', OutOfStockModal)
Vue.component('banner', Banner)

Vue.component('product-return', ProductReturn)
Vue.component('product-return-orders-list', ProductReturnOrdersList)
Vue.component('product-return-product-list', ProductReturnProductList)
Vue.component('product-return-products', ProductReturnProducts)
Vue.component('product-return-summary', ProductReturnSummary)

Vue.component('mpl-parcel-locker', MplParcelLocker)
Vue.component('mpl-pickup-points', MplPickupPoints)
Vue.component('post-offices', PostOffices)
Vue.component('dpd-parcel-locker', DpdParcelLocker)
Vue.component('dpd-parcel-point', DpdParcelPoint)

const store = new Vuex.Store({
    modules: {cart}
})

const loadingInstance = new Vue(Loading).$mount();
document.body.appendChild(loadingInstance.$el);
Vue.prototype.$loading = loadingInstance;


const app = new Vue({
    el: '#app',
    store,
    // vuetify: vuetify,

    created() {
        this.$store.dispatch('cart/load')
    }
});



app.$bus.$on('coupon-redeemed', (coupon) => {
    const payload = {
        items: app.$store.state.cart.items.map(
            item => {
                return {
                    id: item.id.identifier,
                    name: item.name,
                    quantity: item.quantity,
                    price: item.price.gross
                }
            }
        ),
        'coupon': coupon,
        'checkout_step': 1,
        'checkout_option': 'coupon redeemed'
    }

    gtag('event', 'checkout_progress', payload)
})

app.$bus.$on('customer-data-saved', () => {
    let _coupons = app.$store.state.cart.discounts.filter(item => typeof item.code !== undefined)
    let _coupon = ''
    if ( _coupons.length ) {
        _coupon = _coupons[0].code
    }

    const payload = {
        items: app.$store.state.cart.items.map(
            item => {
                return {
                    id: item.id.identifier,
                    name: item.name,
                    quantity: item.quantity,
                    price: item.price.gross
                }
            }
        ),
        'coupon': _coupon,
        'checkout_step': 4,
        'checkout_option': 'contact and delivery details provided'
    }

    gtag('event', 'checkout_progress', payload)
})

app.$bus.$on('cart-item-added', (item) => {
    let category = item.id.type.split('\\')
    category = category[category.length-1]

    const trackingInfo = {
        'id': item.id.identifier.toString(),
        'name': item.name,
        'brand': 'budmil',
        'category': category,
        'quantity': item.quantity,
        'price': item.price.gross.toString()
    }

    const facebookTrackingInfo = {
        value: item.price.gross * item.quantity,
        currency: 'HUF',
        contents: [
            {
                id: item.id.identifier.toString(),
                quantity: item.quantity
            },
        ],
        content_type: 'product',
    }
    gtag('event', 'add_to_cart', {
        "items": [
            trackingInfo
        ]
    })
    fbq('track', 'AddToCart', facebookTrackingInfo)
})

app.$bus.$on('cart-item-removed', (item) => {
    let category = item.id.type.split('\\')
    category = category[category.length-1]

    const trackingInfo = {
        'id': item.id.identifier.toString(),
        'name': item.name,
        'brand': 'budmil',
        'category': category,
        'quantity': item.quantity,
        'price': item.price.gross.toString()
    }

    gtag('event', 'remove_from_cart', {
        "items": [
            trackingInfo
        ]
    })
})

app.$bus.$on('cart-modified', (cart) => {
    loadingInstance.hide()
})

app.$bus.$on('coupon-redeem-error', (error) => {
    loadingInstance.hide()
})

window.app = app
$(document).on('click', '.tablist__tab:not(".tablist__tab--active")', function (event) {
    event.preventDefault();

    $(event.target).closest('.tablist').find('.tablist__tab').removeClass('tablist__tab--active');
    $(event.target).addClass('tablist__tab--active');
    $(event.target).closest('.tablist').find('.tablist__tabpanel--active').slideUp().removeClass('tablist__tabpanel--active');
    $(event.target).closest('.tablist').find('.tablist__tabpanel[data-id=' + $(event.target).data('controls') + ']').slideDown().addClass('tablist__tabpanel--active');

});

/**
 * Remodal
 */

$(document).on('opened', '.remodal', function () {
    $('.region-product-overlay .js-slick').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    });
});


$('.toggle-category').click(function () {
    var visible = $(this).parent().children().not(this).first().is(':visible');

    var removeClass = visible ? 'fa-chevron-up' : 'fa-chevron-down';
    var addClass = visible ? 'fa-chevron-down' : 'fa-chevron-up';

    $(this).find('.toggle-icon').removeClass(removeClass).addClass(addClass);

    $(this).parent().children().not(this).toggle();
});
var slickConfig = {
    lazyLoad: 'ondemand',
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 4,
    slidesToShow: 4,
    responsive: [
        {
            breakpoint: 960,
            settings: {
                slidesToScroll: 3,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 2
            }
        }
    ]
};

$('.accordion-button').on('click', function (event) {
    $(this).toggleClass('open').next('.accordion-content').toggleClass('open');
    $(this).next('.accordion-content').find('.region-products .list.js-slick').slick(slickConfig);
    $('.lazy').Lazy();
});

window.checkPayment = function(event, url, type, key) {
    axios.post(url, {
        order: key,
    })
        .then(response => {
            if(response.data.url) {
                location.href = response.data.url
            } else {
                startPayment(event, type, key);
            }
        })
        .catch(error => {
            console.log('error')
        });
}
